'use client';

import type { FC } from 'react';

import { useTemplateTracker } from '../../hooks/useTemplateTracker';

export const TemplateTracker: FC<{
  title: string;
}> = ({ title }) => {
  useTemplateTracker({
    pageArea: 'Lichtblick Jobs',
    pageType: 'job-detail',
    pageTitle: title,
  });

  return null;
};
